import {
    FIELD_FAMILY,
    FIELD_LEVEL_EQUIPMENT,
    FIELD_PCL_PRICE,
    FIELD_REFERENCE_NUMBER,
    FIELD_SEGMENT,
    FIELD_SPARE_PART_LOCATION,
    FIELD_CURRENT_SPARE_PART_NAME,
    FIELD_TECHNICAL_TYPE,
    LABEL_FAMILY,
    LABEL_LEVEL_EQUIPMENT,
    LABEL_PCL_PRICE,
    LABEL_REFERENCE_NUMBER,
    LABEL_SEGMENT,
    LABEL_SPARE_PART_LOCATION,
    LABEL_CURRENT_SPARE_PART_NAME,
    LABEL_TECHNICAL_TYPE,
    FIELD_SUGGESTED_SPARE_PART_NAME,
    LABEL_SUGGESTED_SPARE_PART_NAME,
    LABEL_PRODUCTION_DATE,
    FIELD_PRODUCTION_DATE,
    FIELD_SUBJECT,
    LABEL_SUBJECT,
    FIELD_BRAND,
    LABEL_BRAND,
    FIELD_MODEL,
    LABEL_MODEL,
    FIELD_VERSION,
    LABEL_VERSION,
    FIELD_ORDER_NUMBER,
    LABEL_ORDER_NUMBER,
    FIELD_VIN,
    LABEL_VIN,
    FIELD_OPTION,
    LABEL_OPTION,
    FIELD_ATTACHMENT,
    LABEL_ATTACHMENT,
    FIELD_NEW_ATTACHMENT,
    LABEL_NEW_ATTACHMENT,
    FIELD_SEND_COPY_TO,
    LABEL_SEND_COPY_TO,
    FIELD_DEALER_NAME,
    LABEL_DEALER_NAME,
    FIELD_DEALER_NUMBER,
    LABEL_DEALER_NUMBER,
    FIELD_MESSAGE,
    LABEL_MESSAGE,
    FIELD_AUTOMATIC_RESPONSE,
    LABEL_AUTOMATIC_RESPONSE,
    FIELD_SFX,
    LABEL_TICKET_NUMBER,
    FIELD_PFX,
    FIELD_DATE_FROM,
    LABEL_DATE_FROM,
    FIELD_DATE_TO,
    LABEL_DATE_TO,
    FIELD_ASSIGNED_TO,
    LABEL_ASSIGNED_TO,
    FIELD_STATUS,
    LABEL_STATUS,
    FIELD_CREATOR_NAME,
    LABEL_CREATOR_NAME,
    FIELD_CREATION_DATE,
    LABEL_CREATION_DATE,
    FIELD_EXPORT_TYPE,
    LABEL_EXPORT_TYPE, FIELD_EXPORT_CHARSET, LABEL_EXPORT_CHARSET
} from './formConstants';

export const marketingFieldLabelMapping = {
    [FIELD_REFERENCE_NUMBER]: LABEL_REFERENCE_NUMBER,
    [FIELD_SEGMENT]: LABEL_SEGMENT,
    [FIELD_PCL_PRICE]: LABEL_PCL_PRICE,
    [FIELD_TECHNICAL_TYPE]: LABEL_TECHNICAL_TYPE,
    [FIELD_FAMILY]: LABEL_FAMILY,
    [FIELD_PRODUCTION_DATE]: LABEL_PRODUCTION_DATE,
    [FIELD_CURRENT_SPARE_PART_NAME]: LABEL_CURRENT_SPARE_PART_NAME,
    [FIELD_SUGGESTED_SPARE_PART_NAME]: LABEL_SUGGESTED_SPARE_PART_NAME,
    [FIELD_SPARE_PART_LOCATION]: LABEL_SPARE_PART_LOCATION,
    [FIELD_LEVEL_EQUIPMENT]: LABEL_LEVEL_EQUIPMENT,
    [FIELD_SUBJECT]: LABEL_SUBJECT,
    [FIELD_BRAND]: LABEL_BRAND,
    [FIELD_MODEL]: LABEL_MODEL,
    [FIELD_VERSION]: LABEL_VERSION,
    [FIELD_ORDER_NUMBER]: LABEL_ORDER_NUMBER,
    [FIELD_VIN]: LABEL_VIN,
    [FIELD_OPTION]: LABEL_OPTION,
    [FIELD_ATTACHMENT]: LABEL_ATTACHMENT,
    [FIELD_NEW_ATTACHMENT]: LABEL_NEW_ATTACHMENT,
    [FIELD_SEND_COPY_TO]: LABEL_SEND_COPY_TO,
    [FIELD_DEALER_NAME]: LABEL_DEALER_NAME,
    [FIELD_DEALER_NUMBER]: LABEL_DEALER_NUMBER,
    [FIELD_MESSAGE]: LABEL_MESSAGE,
    [FIELD_AUTOMATIC_RESPONSE]: LABEL_AUTOMATIC_RESPONSE,
    [FIELD_SFX]: LABEL_TICKET_NUMBER,
    [FIELD_PFX]: LABEL_TICKET_NUMBER,
    [FIELD_DATE_FROM]: LABEL_DATE_FROM,
    [FIELD_DATE_TO]: LABEL_DATE_TO,
    [FIELD_ASSIGNED_TO]: LABEL_ASSIGNED_TO,
    [FIELD_STATUS]: LABEL_STATUS,
    [FIELD_CREATOR_NAME]: LABEL_CREATOR_NAME,
    [FIELD_CREATION_DATE]: LABEL_CREATION_DATE,
    [FIELD_EXPORT_TYPE]: LABEL_EXPORT_TYPE,
    [FIELD_EXPORT_CHARSET]: LABEL_EXPORT_CHARSET,
};
